<aside class="year-panel">
  <h3>{{ 'DATA_MONITORING_YEAR_OVERVIEW' | translate: { year: year() } }}</h3>
  <p class="year-panel__total">{{ 'DATA_MONITORING_YEAR_TOTAL' | translate: { count: totalProblems() } }}</p>
  <ul class="year-panel__months">
    @for (item of months(); track item.month) {
      <li class="year-panel__month" [class.year-panel__month--selected]="item.selected">
        <div class="year-panel__month-head">
          <app-secondary-button [title]="item.nameKey" size="small" (action)="openMonth.emit(item.month)"></app-secondary-button>
          @if (item.problems > 0) {
            <span class="badge badge--problem" [title]="'DATA_MONITORING_MONTH_PROBLEMS' | translate: { count: item.problems }">{{ item.problems }}</span>
          } @else if (item.future) {
            <span class="badge badge--future">—</span>
          } @else {
            <span class="badge badge--clean" [title]="'DATA_MONITORING_MONTH_CLEAN' | translate">✓</span>
          }
        </div>
        @if (item.topRows.length > 0) {
          <ul class="year-panel__rows">
            @for (top of item.topRows; track top.key) {
              <li>
                <app-secondary-button
                  [title]="top.text"
                  size="small"
                  (action)="goToRow.emit({ month: item.month, group: top.group, rowKey: top.key })"
                ></app-secondary-button>
              </li>
            }
            @if (item.more > 0) {
              <li class="year-panel__more">{{ 'DATA_MONITORING_MORE' | translate: { count: item.more } }}</li>
            }
          </ul>
        }
      </li>
    }
  </ul>
</aside>
